define('modules',[
	"controllers/admin/authentication/authenticationController",
	"controllers/admin/blog/blogController",
	"controllers/admin/blog/editPostController",
	"controllers/blog/blogsController"
], function () { });
